import thingApi from '@/api/thing.api'

export const thingService = (function () {
  'use strict'

  /**
   * Para obtener los datos de las cosas para la tabla del ABM
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} enterprises
   * @param {*} types
   */
  async function findAll (pageSize, pageNumber, enterprises, types) {
    if (enterprises && types ) {
        try {
          /*
          if (pageSize > 0 && pageNumber > 0) {
            const response = await thingApi.findAll(pageSize, pageNumber, enterprises, types)
            return response.data
          } else {
            return {
              data: [],
              headers: []
            }
          }
          */
          const response = await thingApi.findAll(undefined, undefined, enterprises, types)
          return response.data
        } catch (exception) {
          console.log(exception)
          return {
            data: [],
            headers: []
          }
        }
    } else {
      return {
        data: [],
        headers: []
      }
    }
    
  }

  async function findAllForGoalsABM(pageSize, pageNumber, enterprises, types) {
    if (enterprises && types ) {
      try {
        const response = await thingApi.findAllForGoalsABM(undefined, undefined, enterprises, types)
        return response.data
      } catch (exception) {
        console.log(exception)
        return {
          data: [],
          headers: []
        }
      }
  } else {
    return {
      data: [],
      headers: []
    }
  }
  }

  async function getEnterpriseGroupEquipmentTreeSelector (thingType = null) {
    try {
        const response = await thingApi.getNested(thingType);
        const lang = localStorage.getItem('locale');
        const data = response.data.map(groupType => {
            return {...groupType, name: groupType.name[lang]}
        });
        return data;
    } catch (e) {
        console.error(e);
        return [];
    }
}

  /**
   * Para obtener el total de cosas de la collection para el paginador de la tabla del ABM
   * @param {*} enterprises
   * @param {*} types
   */
  async function getTotal(enterprises, types) {
    if (enterprises && types) {
        try {
            const response = await thingApi.getTotalCount(enterprises, types)
            return response.data
        } catch (exception) {
            console.log(exception)
            return 0
        }
    } else {
        return 0
    }
  }

  /**
   * Para obtener el arreglo de tipos de cosas para los selectores del ABM
   */
  async function getTypesForSelector() {
    try {
        const response = await thingApi.getTypesForSelector()
        return response.data
    } catch (exception) {
        console.log(exception)
        return []
    }
  }

  /**
   * Para eliminar una cosa
   */
  async function deleteOne(id) {
    try {
        const response = await thingApi.delete(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Para elimincación múltiple
   */
  async function deleteMany(ids) {
    try {
        const response = await thingApi.multipleDelete(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Crea una nueva cosa en la collection
   * @param {*} thing
   */
  async function create(thing) {
    try {
        const response = await thingApi.create(thing)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Actualiza una cosa existente en la collection
   * @param {*} thing
   */
  async function update(thing) { 
    try {
        const response = await thingApi.update(thing)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Devuelve las cosas de una empresa que no estén asignadas a un grupo
   * Se emplea en el ABM de GRUPO
   * @param {*} enterpriseId
   */
  async function getThingsWithoutGroupByEnterpriseId(enterpriseId) {
    try {
      const response = await thingApi.getThingsWithoutGroupByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve las cosas de una empresa que no estén asignadas a una flota
   * Se emplea en el ABM de FLOTAS
   * @param {*} enterpriseId
   */
  async function getThingsWithoutFleetByEnterpriseId(enterpriseId) {
    try {
      const response = await thingApi.getThingsWithoutFleetByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve las cosas de una empresa que no estén asignadas a un frente de trabajo
   * Se emplea en el ABM de FRENTES DE TRABAJO
   * @param {*} enterpriseId
   */
  async function getThingsWithoutWorkFrontByEnterpriseId(enterpriseId) {
    try {
      const response = await thingApi.getThingsWithoutWorkFrontByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve los datos de una cosa para el dialog de ABM
   * @param {*} id
   */
  async function getThing (id) {
    try {
      const response = await thingApi.getThing(id)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Claves de actividades, tipos y sectores para completar los datos para carga masiva
   */
  async function getMassiveUploadInformationData () {
    try {
      const response = await thingApi.getMassiveUploadInformationData()
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        activities: [],
        types: [],
        sectors: [],
        headers: []
      }
    }
  }

  /**
   * Arreglo de cosas (equipos) para utilizar en los selectores
   * (Reporte de comandos enviados)
   */
  async function getAllForSelector () {
    try {
      const response = await thingApi.getAllForSelector()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Selector de vehículos de scoring
   * @param {*} enterpriseIds
   */
  async function getVehicleSelector(enterpriseIds) {
    try {
        let result = await thingApi.getVehicleSelector(enterpriseIds);
        return result.data;
    } catch (e) {
        console.error(e)
        return []
    }
  }

  /**
   * Estructura anidada de cosas para asignar a los usuarios
   * empresas -> grupos -> equipos
   * @param {*} enterpriseIds
   * @param {*} selectedIds
   */
  async function getThingsNestedInEnterprises(enterpriseIds, selectedIds, userId) {
    try {
      if (enterpriseIds.length > 0) {
        let result = await thingApi.getThingsNestedInEnterprises(enterpriseIds, selectedIds, userId);
        return result.data;
      } else {
        return []
      }
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getRuses() {
    try {
      let result = await thingApi.getRuses();
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getRusKeys() {
    try {
      let result = await thingApi.getRusKeys();
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getEnterpriseRusConfiguration(enterpriseId, typeId) {
    try {
      let result = await thingApi.getEnterpriseRusConfiguration(enterpriseId, typeId);
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getEnterpriseEventConfiguration(enterpriseId, typeId) {
    try {
      let result = await thingApi.getEnterpriseEventConfiguration(enterpriseId, typeId);
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getAllNestedByEnterprise(enterpriseIds) {
    try {
      let result = await thingApi.getAllNestedByEnterprise(enterpriseIds);
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getWorkFrontsByEnterpriseId(enterpriseId) {
    try {
      const result = await thingApi.getWorkFrontsByEnterpriseId(enterpriseId);
      return result.data
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getAllNestedByActivity(enterpriseIds) {
    try {
      let result = await thingApi.getAllNestedByActivity(enterpriseIds);
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }

  async function getAllNested(enterpriseIds) {
    try {
      let result = await thingApi.getAllNested(enterpriseIds);
      return result.data;
    } catch (e) {
      console.error(e)
      return []
    }
  }
  
  async function validateIdentificatorCode(identificator) {
    try {
      const result = await thingApi.validateIdentificatorCode(identificator);
      return result.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  async function isGpsAlreadyAssigned(gpsId, thingId) {
    try {
      const result = await thingApi.isGpsAlreadyAssigned(gpsId, thingId);
      return result.data
    } catch (e) {
      console.error(e)
      return false
    }
  }

  async function hasTracksComputed(thingId) {
    try {
      const result = await thingApi.hasTracksComputed(thingId);
      return result.data
    } catch (e) {
      console.error(e)
      return false
    }
  }
  
  async function getDefaultValuesLevelControl() {
    try {
      const result = await thingApi.getDefaultValuesLevelControl();
      return result;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  return {
    findAll,
    getTotal,
    getTypesForSelector,
    deleteOne,
    deleteMany,
    create,
    update,
    getThingsWithoutGroupByEnterpriseId,
    getThingsWithoutFleetByEnterpriseId,
    getThingsWithoutWorkFrontByEnterpriseId,
    getThing,
    getMassiveUploadInformationData,
    getAllForSelector,
    getVehicleSelector,
    getThingsNestedInEnterprises,
    getRuses,
    getRusKeys,
    getEnterpriseRusConfiguration,
    getEnterpriseEventConfiguration,
    getAllNestedByEnterprise,
    getAllNestedByActivity,
    getAllNested,
    getWorkFrontsByEnterpriseId,
    validateIdentificatorCode,
    isGpsAlreadyAssigned,
    hasTracksComputed,
    getEnterpriseGroupEquipmentTreeSelector,
    findAllForGoalsABM,
    getDefaultValuesLevelControl,
  }
})()
